"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var tabs_1 = __importDefault(require("../../ui/tabs"));
var load_1 = require("../../data/load");
var cell_1 = require("../../ui/cell");
var utils_1 = require("../../utils");
var footer_1 = __importDefault(require("./footer"));
var detail_unit_1 = __importDefault(require("./detail-unit"));
var U = __importStar(require("./utils"));
var useStyles = utils_1.makeStyles(function (theme) { return ({
    loaderWrapper: {
        padding: theme.spacing(4, 0)
    }
}); });
var DetailPage = function (_a) {
    var extra = _a.extra, title = _a.title, props = __rest(_a, ["extra", "title"]);
    var DetailComponent = function () { return react_1["default"].createElement(detail_unit_1["default"], __assign({}, props)); };
    var DetailAsExtra = {
        title: title,
        width: props.config.width,
        Component: DetailComponent
    };
    var tabs = U.getTabs(extra).map(function (_a) {
        var k = _a[0], v = _a[1];
        var extras = k === 'null' ? __spreadArrays([DetailAsExtra], v) : v;
        var label = k === 'null' ? 'Detail' : k;
        var link = k === 'null' ? '/detail' : '/' + encodeURI(k);
        return {
            label: label,
            link: link,
            Component: (react_1["default"].createElement(cell_1.Layout, null,
                react_1["default"].createElement(U.Extras, { data: props.data, extras: extras, uuid: props.uuid, PaperComponent: props.PaperComponent, withPaper: props.withPaper })))
        };
    });
    var detailComponentIndex = 0;
    var detailItem = tabs.filter(function (x, i) {
        if (x.link === '/detail') {
            detailComponentIndex = i;
            return true;
        }
        return false;
    })[0];
    if (detailComponentIndex !== 0) {
        tabs.splice(detailComponentIndex);
        tabs.unshift(detailItem);
    }
    var prefix = "" + props.config.urlPrefix + (props.config.detailUrlPrefix ? '/' + props.config.detailUrlPrefix : '') + "/" + props.uuid;
    return (react_1["default"].createElement(react_1["default"].Fragment, null, tabs.length === 1 ? (detailItem.Component) : (react_1["default"].createElement(tabs_1["default"], { prefix: prefix, tabs: tabs, exact: false }))));
};
var DetailLoader = function (props) {
    var _a, _b;
    var Data = props.Data, config = props.config, onBack = props.onBack, onDelete = props.onDelete, NoDataComponent = props.NoDataComponent, noDataMessage = props.noDataMessage, _c = props.extra, extra = _c === void 0 ? [] : _c;
    var params = react_router_dom_1.useParams();
    var location = react_router_dom_1.useLocation();
    var uuid = props.uuid || params.uuid;
    var dataLoad = react_1.useState(Data.detail(uuid))[0];
    var classes = useStyles();
    var detailPrefix = config.urlPrefix + "/" + uuid + "/detail";
    var displayTypeToUse = config.displayType
        ? __assign({}, config.displayType) : undefined;
    var tabs = U.getTabs(extra);
    if (tabs.length > 1 && location.pathname !== detailPrefix) {
        displayTypeToUse = __assign(__assign({}, displayTypeToUse), { "delete": false });
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(load_1.WithLoader, { dataLoad: dataLoad, Component: DetailPage, ViewUI: props.ViewUI, FormUI: props.FormUI, config: config, Data: Data, title: config.title || 'Detail', noDataMessage: noDataMessage, NoDataComponent: NoDataComponent
                ? function (error) { return react_1["default"].createElement(NoDataComponent, { error: error }); }
                : undefined, PaperComponent: config.PaperComponent, withPaper: (_a = config.paper) === null || _a === void 0 ? void 0 : _a.detail, extra: extra, uuid: uuid, LoaderWrapperComponent: function (_a) {
                var _b;
                var children = _a.children;
                return (react_1["default"].createElement(cell_1.Cell, { xs: 12, sm: 12, md: 12, lg: 12, xl: 12, classNames: { paper: classes.loaderWrapper }, withPaper: (_b = config.paper) === null || _b === void 0 ? void 0 : _b.detail }, children));
            } }),
        react_1["default"].createElement(footer_1["default"], { id: uuid, linkBack: config.urlPrefix, deletePromise: Data.deleteById, displayType: displayTypeToUse, onBack: onBack, onDelete: onDelete, message: (_b = config.customMessages) === null || _b === void 0 ? void 0 : _b["delete"] })));
};
exports["default"] = DetailLoader;
